import { render, staticRenderFns } from "./notification_hazardous.vue?vue&type=template&id=18b3070a&scoped=true&"
import script from "./notification_hazardous.vue?vue&type=script&lang=js&"
export * from "./notification_hazardous.vue?vue&type=script&lang=js&"
import style0 from "./notification_hazardous.vue?vue&type=style&index=0&id=18b3070a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b3070a",
  null
  
)

export default component.exports